import { IModularFamily } from '../../../redux/slices/ModularEnrolmentSlice/types';
import { IDependent } from '../../../redux/slices/PolicyListSlice/types';
import { FamilyMemberSortingPreference } from '../../../utils/constants/ModularConstants';
import { FlagsmithFlags, isFlagsmithFeatureEnabled } from '../../../utils/flagsmith';
import { IMappings } from '../../../utils/mapping';
import { IForm } from '../ManageModularMember/types';
import {
    anyOfChildOrSiblingOptions,
    IGetDependentCountReturnType,
    IGetRelationshipReturnType,
    oneOfParentsOrInLawsOptions,
    parentInLawsOptions
} from './types';

export const getCountByrelationUtil = (
    arr:
        | {
              relation: string;
              number: number;
          }[]
        | null
        | undefined,
    r: string
): number => arr?.find((d) => d.relation.toLowerCase() === r)?.number ?? 0;

export const getRelationshipUtil = (category: string, formatCustomConfig = true): IGetRelationshipReturnType => {
    const children = ['1 Kid', '2 Kids', '3 Kids', '4 Kids'];
    const parent = ['Parents', 'Parents Only'];
    const sibling = ['2 Siblings'];
    if (category === 'Spouse') {
        if (isFlagsmithFeatureEnabled(FlagsmithFlags.PARTNER_SUPPORT) && formatCustomConfig) return 'spouse/partner';
        return category;
    } else if (children.includes(category)) return 'child';
    else if (parent.includes(category)) return 'parent';
    else if (sibling.includes(category)) return 'sibling';
    else if (category === 'Parents (including in-laws)') return 'parent/parent-in-law';
    else if (oneOfParentsOrInLawsOptions.includes(category)) return 'parent|parent-in-law';
    else if (anyOfChildOrSiblingOptions.includes(category)) return 'child/sibling';
    else if (parentInLawsOptions.includes(category)) return 'parent-in-law';
    else return '';
};

export const getDependentCountUtil = (
    mappingType: 'target' | 'current',
    relationship: IGetRelationshipReturnType,
    currentMapping: IMappings | null,
    targetMapping: IMappings | null,
    selectedParentId: string
): IGetDependentCountReturnType => {
    let number = 0;
    if (mappingType === 'target') {
        number = getCountByrelationUtil(targetMapping?.dependents, relationship.toLowerCase());
    } else {
        if (relationship.toLowerCase() === 'parent/parent-in-law') {
            number =
                getCountByrelationUtil(currentMapping?.dependents, 'parent') +
                getCountByrelationUtil(currentMapping?.dependents, 'parent-in-law');
        } else if (relationship.toLowerCase() === 'child/sibling') {
            number =
                getCountByrelationUtil(currentMapping?.dependents, 'child') +
                getCountByrelationUtil(currentMapping?.dependents, 'sibling');
        } else if (relationship.toLowerCase() === 'parent|parent-in-law') {
            number = getCountByrelationUtil(currentMapping?.dependents, selectedParentId.toLowerCase());
        } else if (relationship.toLowerCase() === 'spouse/partner') {
            number =
                getCountByrelationUtil(currentMapping?.dependents, 'spouse') +
                getCountByrelationUtil(currentMapping?.dependents, 'partner');
        } else {
            number = getCountByrelationUtil(currentMapping?.dependents, relationship.toLowerCase());
        }
    }
    return { relation: relationship, number };
};

export const getAddMemberCardCount = (
    relation: string,
    currentMapping: IMappings | null,
    targetMapping: IMappings | null,
    selectedParentId: string
): number => {
    const targetCount =
        getDependentCountUtil(
            'target',
            getRelationshipUtil(relation, false),
            currentMapping,
            targetMapping,
            selectedParentId
        )?.number || 0;

    const currentCount =
        getDependentCountUtil('current', getRelationshipUtil(relation), currentMapping, targetMapping, selectedParentId)
            ?.number || 0;
    return Math.max(targetCount - currentCount, 0);
};

export const initialFormValues: IForm = {
    firstName: '',
    lastName: '',
    dob: '',
    gender: '',
    relationship: '',
    mobile: ''
};

export const sortFamilyMembers = (family: (IModularFamily | IDependent)[]): (IModularFamily | IDependent)[] => {
    return structuredClone(family).sort(
        (a, b) =>
            FamilyMemberSortingPreference[a.relationship?.toLowerCase()] -
            FamilyMemberSortingPreference[b.relationship?.toLowerCase()]
    );
};
